import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {PlataformasDigitalesValidaciones} from "../_models/plataformas-digitales-validaciones";
import {AutenticacionService} from "./autenticacion.service";

@Injectable({
  providedIn: 'root'
})
export class PlataformasDigitalesValidacionesService {

  private rutServicio = AppSettings.rutServiciosAUTOGES + '/api/plataformasDigitalesValidaciones';


  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httpClient.get( this.rutServicio).pipe( map( res => res as PlataformasDigitalesValidaciones[] ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + '/indicadorHabilitado/orden/asc' ).pipe( map( res => res as PlataformasDigitalesValidaciones[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PlataformasDigitalesValidaciones ) );
  }

  crear( regCrear: PlataformasDigitalesValidaciones ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PlataformasDigitalesValidaciones ) );
  }

  actualizar( regActualizar: PlataformasDigitalesValidaciones ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as PlataformasDigitalesValidaciones ) );
  }
}
